import React from "react";

const FooterF = () => {
  return (
    <footer className="w-full bg-[#F2EFEA]">
      {/* Main Grid Section with Borders */}
      <div className="grid grid-cols-1 md:grid-cols-12 border-t border-b border-gray-900 bg-[#F2EFEA] text-gray-900">
        {/* Left Column */}
        <div
          className="col-span-12 md:col-span-4 border-b md:border-b-0 md:border-r border-gray-900 py-6 md:py-10 lg:py-20 flex justify-center"
          style={{
            fontFamily: "uberschrift-Regular",
          }}
        >
          <div className="flex flex-col justify-center items-center space-y-4">
            <p className="text-base md:text-lg lg:text-xl font-light italic tracking-wide cursor-pointer hover:text-gray-600">
              SOCIAL MEDIA MANAGEMENT
            </p>
            <p className="text-base md:text-lg lg:text-xl font-light italic tracking-wide cursor-pointer hover:text-gray-600">
              CREATIVE SERVICES
            </p>
            <p className="text-base md:text-lg lg:text-xl font-light italic tracking-wide cursor-pointer hover:text-gray-600">
              CONSULTING
            </p>
          </div>
        </div>

        {/* Center Column */}
        <div
          className="col-span-12 md:col-span-4 border-b md:border-b-0 flex justify-center items-center py-6 md:py-10 lg:py-20 text-center border-gray-900"
          style={{
            fontFamily: "uberschrift-Regular",
          }}
        >
          <h1 className="text-xl md:text-2xl lg:text-3xl font-normal tracking-wide">
            CONNECT ENGAGE GROW
          </h1>
        </div>

        {/* Right Column */}
        <div
          className="col-span-12 md:col-span-4 md:border-l border-gray-900 py-6 md:py-10 lg:py-20 flex justify-center"
          style={{
            fontFamily: "uberschrift-Regular",
          }}
        >
          <div className="flex flex-col justify-center items-center space-y-4">
            <p className="text-base md:text-lg lg:text-xl font-light italic tracking-wide cursor-pointer hover:text-gray-600">
              CONTACT
            </p>
            <p className="text-base md:text-lg lg:text-xl font-light italic tracking-wide cursor-pointer hover:text-gray-600">
              FAQS
            </p>
            <p className="text-base md:text-lg lg:text-xl font-light italic tracking-wide cursor-pointer hover:text-gray-600">
              INQUIRE
            </p>
          </div>
        </div>
      </div>

      {/* Gmail Section */}
      <div className="bg-[#F2EFEA]">
        <div className="col-span-12 text-center py-3 md:py-4">
          <p
            className="text-xs md:text-sm text-gray-600 tracking-wide px-4"
            style={{
              fontFamily: "uberschrift-Regular",
            }}
          >
            CONNECTENGAGEGROW.CEG@GMAIL.COM
          </p>
        </div>
      </div>

      {/* Social Icons Section */}
      <div className="border-b border-gray-900">
        <div className="max-w-7xl mx-auto py-4 md:py-6 lg:py-8 flex justify-center space-x-4">
          {/* Instagram Icon */}
          <a href="#" className="hover:opacity-70">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              className="w-5 h-5 md:w-6 md:h-6"
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
          {/* Facebook Icon */}
          <a href="#" className="hover:opacity-70">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              className="w-5 h-5 md:w-6 md:h-6"
            >
              <path d="M22.675 0h-21.35c-.733 0-1.325.592-1.325 1.325v21.351c0 .733.592 1.325 1.325 1.325h11.495v-9.29h-3.125v-3.622h3.125v-2.672c0-3.1 1.893-4.787 4.659-4.787 1.325 0 2.464.099 2.794.143v3.241h-1.918c-1.504 0-1.796.715-1.796 1.763v2.311h3.591l-.467 3.622h-3.124v9.29h6.124c.733 0 1.325-.592 1.325-1.325v-21.35c0-.733-.592-1.325-1.325-1.325z" />
            </svg>
          </a>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="max-w-7xl mx-auto py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-6 text-center px-4">
          <span className="text-xs md:text-sm font-light">
            © Connect Engage Grow™ 2024
          </span>
          <span className="text-xs md:text-sm font-light cursor-pointer hover:text-gray-600">
            Terms
          </span>
          <span className="text-xs md:text-sm font-light cursor-pointer hover:text-gray-600">
            Privacy Policy
          </span>
          <span className="text-xs md:text-sm font-light">
            Designed & Developed by AUTOROBOS
          </span>
        </div>
      </div>
    </footer>
  );
};

export default FooterF;
